import {graphql} from 'gatsby'
import React from 'react'

import type {LatestBlogPostsSliceFragment} from '@/graphql-types'
import {LatestBlogPosts} from '@/sections/latest-blog-posts'

interface Props {
    slice: LatestBlogPostsSliceFragment
    dataTestId?: string
}

export const LatestBlogPostsSlice = ({slice, dataTestId}: Props) => {
    const {cta_link, cta_text, title} = slice.primary

    return (
        <LatestBlogPosts
            title={title}
            ctaLink={cta_link}
            ctaText={cta_text}
            dataTestId={dataTestId}
        />
    )
}

export const latestBlogPostsSliceFragment = graphql`
    fragment LatestBlogPostsSlice on PrismicSlicePageDataBodyLatestBlogPosts {
        __typename
        primary {
            title
            cta_text
            cta_link {
                ...PrismicLink
            }
        }
    }
`
